import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { KYMW1205Component } from './kymw1205.component';

/**
 * メモ編集画面 モジュール設定クラス
 *
 * @export KYMW1205Module
 * @class KYMW1205Module
 */
@NgModule({
  imports: [CommonModule, FormsModule, PlessSharedModule, AppCommonsModule],
  declarations: [KYMW1205Component],
  providers: [],
})
export class KYMW1205Module {}
